import * as React from "react";
import MuiButton, { ButtonProps } from "@material-ui/core/Button/Button";
import classNames from "../../utils/classNames";
import { Theme } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";

type Props = ButtonProps & {
  classes?: any;
  id: string;
};

type State = {};

const styles = (theme: Theme) =>
  createStyles({
    button: {
      textTransform: "unset",
      "&:disabled": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        opacity: 0.4
      }
    },
    naked: {
      backgroundColor: theme.palette.background.default
    }
  });

class Button extends React.Component<Props, State> {
  render() {
    const {
      children,
      color = "inherit",
      className,
      classes,
      disabled,
      id,
      variant = "contained"
    } = this.props;

    const buttonClasses = [classes.button, className];
    if (color === "inherit") {
      buttonClasses.push(classes.naked);
    }
    if (variant === "contained" && disabled) {
      buttonClasses.push(classes.disabled);
    }

    return (
      <MuiButton
        {...this.props}
        classes={{
          disabled: classes.disabled
        }}
        data-test-control={id}
        variant={variant}
        className={classNames(buttonClasses, className)}
      >
        {children}
      </MuiButton>
    );
  }
}

const styled = withStyles(styles)(Button);

export { styled as Button };
